import styled from 'styled-components'
import RouteContainer from '../../../common/styles/RouteContainer'
import RowSpacer from '../../../common/styles/RowSpacer'
import BookGoalCard from './BookGoalCard'
import RouteTitle from '../../../common/RouteTitle/RouteTitle'
import booksitoutIcon from '../../../config/BooksitoutIcon'
import RouteTitleConfig from '../../../config/RouteTitleConfig'
import AddDeleteButton from '../../../common/button/AddDeleteButton'
import BookGoalAddModal from './BookGoalAddModal'
import React, { useEffect, useState } from 'react'
import useBookGoalsAll from './useBookGoals'
import { BooksitoutServer } from '../../../config/BooksitoutServer'
import toast from 'react-hot-toast'
import useBookGoalStore from './useBookGoalStore'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import { Row } from 'react-bootstrap'
import breakpoints from '../../../config/Breakpoints'
import BookResponse from '../BookResponse'
import useHtmlTitle from '../../../common/useHtmlTitle'

const BookGoalRoute = () => {
	useHtmlTitle('목표')
	const { init, goals, getGoal, deleteGoal } = useBookGoalStore()

	const [goalsFromServer, isLoading] = useBookGoalsAll()
	useEffect(() => {
		init(goalsFromServer)
	}, [goalsFromServer])

	const [isAddModalOpen, setIsAddModalOpen] = useState<boolean>(false)
	const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear())

	const onAdd = (year: number) => {
		setIsAddModalOpen(true)
		setSelectedYear(year)
	}

	const onDelete = (year: number) => {
		if (!window.confirm(`${year}년도 목표를 삭제할까요?`)) {
			return
		}

		BooksitoutServer.delete(`/v1/book/goals/${year}`)
			.then(() => {
				deleteGoal(year)
				toast.success('목표가 삭제되었습니다.')
			})
			.catch(() => toast.error('오류가 발생했어요. 잠시 후 다시 시도해 주세요.'))
	}

	const onHide = () => {
		setIsAddModalOpen(false)
	}

	return (
		<RouteContainer>
			<RouteTitle icon={<booksitoutIcon.book />} title={'내 서재'} subTitle={'내가 등록한 책을 확인하고 관리할 수 있어요'} currentKey={'mine'} buttons={RouteTitleConfig.Book} rightUi={undefined} />

			<BookGoalAddModal isOpen={isAddModalOpen} onHide={onHide} year={selectedYear} />
			<RowSpacer/>

			{Array.from({ length: 12 })
				.map((_, index) => new Date().getFullYear() - index)
				.map(year => {
					const goal = goals.find(g => g.year === year)
					const percent = goal && goal.total > 0 ? Math.min(100, Math.max(0, Math.ceil((goal.current / goal.total) * 100))) : 0
					return (
						<>
							<CardBodyContentContainer height={100} percent={percent} style={{ position: 'relative' }}>
								<TitleContainer>
									<YearText>{year}년</YearText>
									{isLoading ? <></> : <AddDeleteButton state={getGoal(year) == null ? 'ADD' : 'DELETE'} onAdd={() => onAdd(year)} onDelete={() => onDelete(year)} />}
								</TitleContainer>
								<RowSpacer size={10} />

								<Row>
									<Col>
										<CardBodyContentContainer style={{ backgroundColor: 'var(--card-card-bg-color)', cursor: 'pointer' }} className={'justify-content-center'} onClick={() => getGoal(year) == null ? onAdd(year) : onDelete(year)}>
											<span className={'d-block d-md-none'}>
												<BookGoalCard year={year} isLoading={isLoading} size={50} isCenter={true}/>
											</span>

											<span className={'d-none d-md-block'}>
												<BookGoalCard year={year} isLoading={isLoading} size={75} isCenter={true}/>
											</span>
										</CardBodyContentContainer>
									</Col>

									<span className={'d-block d-md-none mb-3'} />

									<BookCoverWrapper>
										<BookCoverCol>
											<GoalBookCover books={getGoal(year)?.books ?? []} />
										</BookCoverCol>
									</BookCoverWrapper>
								</Row>

								<div
									style={{
										position: 'absolute',
										bottom: 0,
										left: 0,
										height: '4px',
										width: `${percent}%`,
										backgroundColor: '#1cb15a',
										boxShadow: '0 2px 5px rgba(28, 177, 90, 0.6)',
										borderBottomLeftRadius: '16px',
										borderBottomRightRadius: percent >= 100 ? '16px' : '2px',
									}}
								></div>
							</CardBodyContentContainer>
							<RowSpacer size={30} />
						</>
					)
				})}
		</RouteContainer>
	)
}

const GoalBookCover: React.FC<{ books: BookResponse[] }> = ({ books }) => {
	if (books.length === 0) {
		return <></>
	}

	return books.map(book => (
		<a href={`/book/mine/${book.id}`} key={book.id} rel={'noreferrer'}>
			<Cover key={book.cover} src={book.cover!!} />
		</a>
	))
}

const Col = styled.div.attrs({
	className: 'col-12 col-md-6 col-lg-5 col-xl-4 clickable',
})``

const BookCoverWrapper = styled.div.attrs({
	className: 'col-12 col-md-6 col-lg-7 col-xl-8',
})`
	position: relative;
	height: 95px;
	padding-top: 20px;

	&::after {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		width: 60px;
		height: 100%;
		background: linear-gradient(to right, transparent, var(--card-bg-color));
		pointer-events: none;
		z-index: 1;
	}

	@media screen and (max-width: ${breakpoints.md}) {
		padding-top: 0;
		height: 80px;
	}
`

const BookCoverCol = styled.div`
	overflow-x: auto;
	overflow-y: hidden;
	height: 100%;
	display: flex;
	flex-wrap: nowrap;
	gap: 6px;

	&::-webkit-scrollbar {
		display: none;
	}
	-ms-overflow-style: none;
	scrollbar-width: none;
`

const TitleContainer = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
`

const YearText = styled.h1`
	font-size: 35px;
	font-weight: bold;
	width: 90%;
	color: var(--text-color);
`

const Cover = styled.img`
	height: 75px;
	border-radius: 5px;
	flex-shrink: 0;
`

export default BookGoalRoute
